import { END_DATE, HOTLINE, START_DATE } from "constants/common";
import TheBanner from "layout/TheBanner/TheBanner";
import TheFooter from "layout/TheFooter";
import TheHeader from "layout/TheHeader";
import React, { useEffect, useState } from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import { useDispatch } from "react-redux";

import routes from "routes";
import actions from "redux/home/actions";
import PopupMessage from "components/popup-message";
import moment from "moment";

const TheRoutes = () => {
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const [content, setContent] = useState("");
  const [nameBtn, setNameBtn] = useState("");

  const nav = routes.map((elm) => {
    return <Route key={elm.path} path={elm.path} element={elm.element} />;
  });
  const clickAction = () => {
    hideModal();
    if (nameBtn === `ĐÓNG`) return;

    const url = `https://stsunlightbtaskee26qa.z23.web.core.windows.net/`;

    window.location.replace(url);
  };
  const hideModal = () => {
    setModal(false);
    setContent("");
    setNameBtn("");

    document.body.classList.remove("modal-open");
  };
  const showModal = () => {
    setModal(true);
    document.body.classList.add("modal-open");
  };
  useEffect(() => {
    let content = "";
    let startDate = moment(START_DATE, "DD/MM/YYYY"); //20/03/2023
    let endDate = moment(END_DATE, "DD/MM/YYYY"); //20/05/2023
    let today = moment();

    if (today < startDate) {
      content = `
      <h5>Chương trình <br/>
chưa bắt đầu</h5>
      
      <p>Chương trình chưa bắt đầu.<br/>
Vui lòng quay trở lại vào ngày ${START_DATE}. <br/> Hotline ${HOTLINE}.</p>
    `;
      setNameBtn(`Not Vietnam? back to homepage`);
      showModal();
      setContent(`${content}`);
      return;
    }
  }, []);
  return (
    <BrowserRouter>
      {modal && (
        <PopupMessage
          nameBtn={nameBtn}
          setModal={setModal}
          content={content}
          clickAction={clickAction}
        />
      )}
      {/* <TheHeader /> */}
      <TheBanner />
      <main>
        <Routes>{nav}</Routes>
      </main>
      {/* <TheFooter /> */}
    </BrowserRouter>
  );
};

export default TheRoutes;
